'use client';

import { projectsConfig } from '@/features/projects/projects.config';
import { useT } from 'next-i18next/client';
import type { FC } from 'react';

export const HeroBlock: FC = () => {
  const { t } = useT(projectsConfig.i18nNamespaces);

  return (
    <div className="bg-[#0A0A0A] relative min-h-[50vh] flex flex-col justify-end">
      <div className="container pb-24 relative">
        <p className="text-xs font-medium tracking-widest uppercase text-[#F24E1E] mb-6">
          {t('projects:hero.label')}
        </p>
        <h1 className="text-[clamp(40px,6vw,72px)] font-medium tracking-[-0.025em] leading-[1] text-white max-w-3xl">
          {t('projects:hero.title')}
        </h1>
        <p className="mt-6 text-base text-white/60 max-w-md leading-6">
          {t('projects:hero.description')}
        </p>
      </div>
    </div>
  );
};
